<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
        >在线文档</span
      >
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData">
      </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import onlineDoc from '../components/onlineDoc'

import { OPEN_API_TEST, OPEN_API_PRO } from '@/constants/index'
const apiUrlTest = 'order/customs/query/waybillIds'
export default {
  components: { onlineDoc },
  computed: {
    ...mapGetters(['token', 'uuid']),
    address() {
      return this.uuid.length > 0 ? `?uuid=${this.uuid}` : ''
    }
  },
  data() {
    return {
      mainStatus: 'online',
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: '根据运单号查询海关申报状态。',
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
        postDataList: [
          //   请求头参数
          {
            title: 'Headers',
            value: [
              {
                name: 'apiAccount',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '接入方在平台的api账户标识'
              },
              {
                name: 'digest',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '签名字符串'
              },
              {
                name: 'timestamp',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '时间戳，毫秒'
              }
            ]
          },
          {
            title: '请求参数',
            value: [
              {
                name: 'bizContent',
                type: 'String',
                require: 'Y',
                normal: '业务参数',
                describe: '业务参数模块内json格式的string类型'
              }
            ]
          },
          {
            title: '业务参数',
            value: [
              {
                name: 'waybillIds',
                type: 'List[]',
                require: 'Y',
                normal: '',
                describe: '运单号'
              },
            ]
          }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [
          //   响应参数
          {
            title: '响应参数',
            value: [
              {
                name: 'code',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '返回码，见附录'
              },
              {
                name: 'msg',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '描述'
              },
              {
                name: 'data',
                type: 'Object',
                require: 'Y',
                normal: '',
                describe: '业务数据'
              }
            ]
          },
          {
            title: 'data类型说明',
            value: [
              { name: 'waybillId', type: 'String', require: 'N', normal: '', describe: '运单号	' },
              { name: 'customsCode', type: 'String', require: 'N', normal: '', describe: '报关海关<p>SHANGHAI：上海海关</p><p>SHENZHEN：深圳海关</p>' },
              { name: 'declarationStatus', type: 'String', require: 'N', normal: '', describe: '申报状态<p>NOT_PUSH：未推送申报</p><p> PUSH_FAILURE：推送申报失败</p><p>ALREADY_PUSH：已推送申报</p><p>FAILURE：申报失败</p><p>SUCCESS：申报成功</p><p>GREEN_LIGHT：实货放行</p>' },
              { name: 'pushDeclarationTime', type: 'String', require: 'N', normal: '', describe: '推送时间' },
              { name: 'declarationFailureReasons', type: 'String', require: 'N', normal: '', describe: '失败原因' },
              { name: 'declarationFeedbackTime', type: 'String', require: 'N', normal: '', describe: '申报反馈时间' }
            ]
          }
        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent= {"waybillIds": ["UT0000547380323", "UT0000547380323"]} `,
        //返回示例
        responseCode: JSON.parse(`{
    "code": "1",
    "msg": "请求成功",
    "data": [
        {
            "waybillId":"UT0000547380323",
            "customsCode":"SHANGHAI",
            "customsName":"上海海关",
            "declarationMode":"AUTO",
            "declarationModeDesc":"自动申报",
            "declarationStatus":"ALREADY_PUSH",
            "declarationStatusName":"已推送申报",
            "pushDeclarationTime":"2023-02-06 13:36:45"
        }
    ],
    "fail": false,
    "succ": true
}
`),

        //错误代码提示
        errcodeJson: []
      },

      apiTestData: {
        _headerData: {
          apiAccount: '1001',
          digest: 'U40e5sumorgd3YgZzU61Mw==',
          timestamp: '1565238848921'
        },
        data: {
          bizContent: `{"type":"1001","params":["测试短信","12000元"],"waybillNo":"123456"}`
        },
        //必须要验证的参数
        requestData: ['apiAccount', 'digest', 'timestamp', 'bizContent'],
        textareaData: {
          bizContent: true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: '',
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: []
      }
    }
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/apiTest.scss';
</style>
